import React from 'react'
import { useTranslation } from 'react-i18next'
import { IdealAnswerItem } from '../types'
import QuizBulletEditor from '../../OldPortalComponents/QuizBulletEditor'

interface BulletQuestionProps {
  questionId: string
  idealAnswer: string
  idealAnswerItems: IdealAnswerItem[]
  turnOnEnhancedKeywords: boolean
  onAnswerChange: (value: string) => void
  onCardDelete: (id: number) => void
  onInputEdit: (
    event: React.ChangeEvent<HTMLTextAreaElement>,
    id: number,
  ) => void
  onPaste: (event: React.ClipboardEvent, id: number) => void
  onKeyUp: (event: React.KeyboardEvent, id: number) => void
  onKeywordsInputChange: (
    event: React.ChangeEvent<HTMLTextAreaElement>,
    id: number,
  ) => void
  onPointScoreChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number,
  ) => void
}

const BulletQuestion: React.FC<BulletQuestionProps> = ({
  questionId,
  idealAnswer,
  idealAnswerItems,
  turnOnEnhancedKeywords,
  onAnswerChange,
  onCardDelete,
  onInputEdit,
  onPaste,
  onKeyUp,
  onKeywordsInputChange,
  onPointScoreChange,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <h4 className="page-subheading">{t('Answer Key')}</h4>
      <QuizBulletEditor
        spellCheck={false}
        identifier={questionId}
        data={idealAnswerItems}
        handleCardDelete={onCardDelete}
        onInputEdit={onInputEdit}
        handlePaste={onPaste}
        shouldAutoFocus={false}
        handleKeyUp={onKeyUp}
        turnOnKeywords={turnOnEnhancedKeywords}
        keywordsInputChange={onKeywordsInputChange}
        paraData={idealAnswer}
        onParaChange={onAnswerChange}
        pointScoreChange={onPointScoreChange}
      />
    </>
  )
}

export default BulletQuestion
